/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, OnChanges} from '@angular/core';
import * as _ from 'lodash';
import * as moment from 'moment';
import {TargetingHelper} from '../targeting-helper';

import template from './date-targeting-summary.component.html';

@Component({
  standalone: false,
  selector: 'adn-targeting-date-targeting-summary',
  template
})
export class DateTargetingSummaryComponent implements OnChanges {
  @Input() targets: any;

  data: Array<{first: any; second: any; entireDay: boolean; sameDay: boolean}> = [];

  ngOnChanges(): void {
    const target = this.targets || {};
    this.data = [];
    _.forEach(target.dateRanges, (v) => {
      this.data.push({
        first: v.first,
        second: v.second,
        entireDay: TargetingHelper.isEntireDay(v),
        sameDay: moment(v.first).isSame(moment(v.second), 'day')
      });
    });
  }
}
